export const getB2CRedirectSignInUrl = () => {
    //non- production 
    return "https://stateofneb2c.b2clogin.com/stateofneb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_IDENTITY_MANAGEMENT_PRD_SIGNUP_SIGNIN&client_id=73fbed97-8f98-492c-9db7-47b4c6b3bb8f&nonce=defaultNonce&redirect_uri=" +

        //local
        "https://ciaam-dhhs.nebraska.gov/external-home" +

        "/&scope=openid 73fbed97-8f98-492c-9db7-47b4c6b3bb8f&response_type=code&isMFA=true&response_mode=query";
}

export const getB2CRedirectLogoutUrl = (): string => {
    return "https://stateofneb2c.b2clogin.com/stateofneb2c.onmicrosoft.com/oauth2/v2.0/logout?p=B2C_1A_IDENTITY_MANAGEMENT_PRD_SIGNUP_SIGNIN&post_logout_redirect_uri=" +

        //local
        "https://ciaam-dhhs.nebraska.gov/"
}

export const getIdMeBaseApiUrl = () => {
    return "https://ciaam-dhhs.nebraska.gov/api";
}